var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogotipo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 508.947,
    height: 177.712,
    viewBox: "0 0 508.947 177.712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_142",
    "data-name": "Grupo 142",
    transform: "translate(3097 -1906.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_144",
    "data-name": "Caminho 144",
    d: "M543.66,2298.42h-1.78l-2.9-8.09h1.63l2.19,6.6h0l2.24-6.6h1.49Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_145",
    "data-name": "Caminho 145",
    d: "M548.22,2290.9a5.189,5.189,0,0,1,2.66-.76c2.32,0,3.25,1.14,3.25,3.35v3.34a12.681,12.681,0,0,0,.07,1.59h-1.4v-1.05h0a3,3,0,0,1-2.5,1.24c-1.75,0-3-.76-3-2.52,0-2,2.22-2.67,3.76-2.67h1.58c0-1.4-.5-2.11-2-2.11a3.789,3.789,0,0,0-2.35.82Zm4.42,3.67h-.95c-.81,0-2.8.13-2.8,1.56a1.42,1.42,0,0,0,1.5,1.31,2,2,0,0,0,2.25-2.12Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_146",
    "data-name": "Caminho 146",
    d: "M556.68,2286.53h1.49v11.89h-1.49Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_147",
    "data-name": "Caminho 147",
    d: "M564.32,2290.14a4,4,0,0,1,4.11,4.23,4.12,4.12,0,1,1-8.23,0,4,4,0,0,1,4.12-4.23Zm0,7.26c1.75,0,2.52-1.58,2.52-3a2.57,2.57,0,1,0-5.05,0C561.79,2295.82,562.56,2297.4,564.32,2297.4Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_148",
    "data-name": "Caminho 148",
    d: "M570.27,2290.33h1.39v1.26h0a2.47,2.47,0,0,1,2.11-1.45,4.348,4.348,0,0,1,1,.11v1.34a2,2,0,0,0-.82-.15c-1.33,0-2.2,1.27-2.2,3.3v3.68h-1.49Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_149",
    "data-name": "Caminho 149",
    d: "M578.05,2288.53h-1.68v-1.68h1.68Zm-1.59,1.8H578v8.09h-1.49Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_150",
    "data-name": "Caminho 150",
    d: "M579.93,2297.12l4.66-5.58h-4.44v-1.21h6.17v1.3l-4.66,5.58h4.83v1.21h-6.56Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_151",
    "data-name": "Caminho 151",
    d: "M594.48,2298.08a6.088,6.088,0,0,1-2.55.53c-2.87,0-4.19-1.75-4.19-4.38a3.76,3.76,0,0,1,3.79-4.09c2.7,0,3.57,2,3.57,4.57h-5.77a2.64,2.64,0,0,0,2.66,2.69,4.668,4.668,0,0,0,2.49-.81Zm-1-4.48a2,2,0,0,0-2-2.25,2.23,2.23,0,0,0-2.17,2.25Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_152",
    "data-name": "Caminho 152",
    d: "M600.58,2296.83a4,4,0,0,0,1.86.57c.68,0,1.52-.28,1.52-1.15,0-1.48-3.51-1.35-3.51-3.62,0-1.68,1.26-2.49,2.86-2.49a6.333,6.333,0,0,1,1.85.32l-.13,1.3a4.249,4.249,0,0,0-1.56-.41c-.76,0-1.43.31-1.43,1,0,1.65,3.5,1.17,3.5,3.76a2.55,2.55,0,0,1-2.82,2.52,4.588,4.588,0,0,1-2.22-.45Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_153",
    "data-name": "Caminho 153",
    d: "M613.39,2298.08a6.088,6.088,0,0,1-2.55.53c-2.87,0-4.19-1.75-4.19-4.38a3.76,3.76,0,0,1,3.79-4.09c2.69,0,3.56,2,3.56,4.57h-5.76a2.64,2.64,0,0,0,2.66,2.69,4.729,4.729,0,0,0,2.49-.81Zm-1-4.48a2,2,0,0,0-2-2.25,2.23,2.23,0,0,0-2.17,2.25Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_154",
    "data-name": "Caminho 154",
    d: "M623,2298.42h-1.44v-1.29h0a2.92,2.92,0,0,1-2.65,1.48c-2.09,0-3-1.3-3-3.47v-4.81h1.49v4.19c0,1.88.41,2.8,1.71,2.88,1.7,0,2.46-1.36,2.46-3.33v-3.74H623Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_155",
    "data-name": "Caminho 155",
    d: "M633.91,2291.54h-2.14V2296a1.28,1.28,0,0,0,1.25,1.44,1.907,1.907,0,0,0,1-.28v1.26a4.581,4.581,0,0,1-1.27.23c-1.54,0-2.49-.73-2.49-2.35v-4.72h-1.82v-1.21h1.82v-1.87l1.49-.47v2.34h2.14Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_156",
    "data-name": "Caminho 156",
    d: "M641.82,2298.08a6.087,6.087,0,0,1-2.55.53c-2.87,0-4.19-1.75-4.19-4.38a3.76,3.76,0,0,1,3.79-4.09c2.69,0,3.57,2,3.57,4.57h-5.77a2.64,2.64,0,0,0,2.66,2.69,4.731,4.731,0,0,0,2.49-.81Zm-1-4.48a2,2,0,0,0-2-2.25,2.23,2.23,0,0,0-2.17,2.25Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_157",
    "data-name": "Caminho 157",
    d: "M644.26,2290.33h1.39v1.18h0a2.729,2.729,0,0,1,2.57-1.37,2.39,2.39,0,0,1,2.3,1.57,2.88,2.88,0,0,1,2.5-1.57c2.06,0,2.81,1.33,2.81,3.09v5.19h-1.49v-4.82c0-1-.24-2.25-1.44-2.25-1.52,0-2.13,1.49-2.13,3v4.08h-1.49v-4.82c0-1-.23-2.25-1.44-2.25-1.52,0-2.12,1.49-2.12,3v4.08h-1.49Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_158",
    "data-name": "Caminho 158",
    d: "M658.2,2290.33h1.43v1.14h0a3.249,3.249,0,0,1,2.74-1.33c2.35,0,3.49,1.92,3.49,4.09s-1,4.38-3.47,4.38a2.911,2.911,0,0,1-2.7-1.3h0v4.43H658.2Zm3.89,1c-1.62,0-2.4,1.54-2.4,3,0,1.35.7,3,2.38,3s2.27-1.79,2.23-3.06c.04-1.38-.6-2.92-2.21-2.92Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_159",
    "data-name": "Caminho 159",
    d: "M671.31,2290.14a4,4,0,0,1,4.1,4.23,4.11,4.11,0,1,1-8.22,0,4,4,0,0,1,4.12-4.23Zm0,7.26c1.74,0,2.52-1.58,2.52-3a2.57,2.57,0,1,0-5.06,0C668.77,2295.82,669.55,2297.4,671.31,2297.4Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_160",
    "data-name": "Caminho 160",
    d: "M246.26,2245.4h-1l-52.11,30.09a7.69,7.69,0,0,0,0,13.32l49.3,28.46a7.628,7.628,0,0,0,3.84,1Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_161",
    "data-name": "Caminho 161",
    d: "M246.26,2245.4h1l52.11,30.09a7.7,7.7,0,0,1,0,13.32l-49.3,28.46a7.669,7.669,0,0,1-3.85,1Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_162",
    "data-name": "Caminho 162",
    d: "M315.51,2201.39,256.8,2167.5a21.159,21.159,0,0,0-21.08,0L177,2201.39a21.14,21.14,0,0,0-10.53,18.26v67.79A21.13,21.13,0,0,0,177,2305.69l58.71,33.9a21.17,21.17,0,0,0,21.08,0l58.71-33.9a21.14,21.14,0,0,0,10.54-18.25v-67.79A21.15,21.15,0,0,0,315.51,2201.39Zm-1,86.05a9.61,9.61,0,0,1-4.79,8.3l-58.71,33.89a9.6,9.6,0,0,1-9.58,0l-58.71-33.89a9.63,9.63,0,0,1-4.79-8.3v-67.79a9.63,9.63,0,0,1,4.79-8.3l58.71-33.9a9.67,9.67,0,0,1,9.58,0l58.71,33.9a9.61,9.61,0,0,1,4.79,8.3Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_163",
    "data-name": "Caminho 163",
    d: "M348.7,2253.4c0-13.54,10-28,28.44-28s28.44,14.42,28.44,28-10,28.15-28.44,28.15S348.7,2267.14,348.7,2253.4Zm12.67.19a15.74,15.74,0,0,0,15.77,16.16c8.7,0,15.67-6.871,15.67-16.26s-7-16.25-15.67-16.25-15.77,6.87-15.77,16.25Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_164",
    "data-name": "Caminho 164",
    d: "M412.15,2227h12v7c2.33-4.75,6.69-8.53,14.73-8.63v12.79h-.58c-8.91,0-13.47,4.17-13.47,13.38v28.68H412.15Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_165",
    "data-name": "Caminho 165",
    d: "M446.35,2227H459v53.2H446.35Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_166",
    "data-name": "Caminho 166",
    d: "M522.62,2273.82c0,8.71-1.64,14.32-4.93,18.77-4.55,6.09-13.45,10.93-24.38,10.93-16.54,0-24.47-9.87-26.41-18.09h14.71a11.93,11.93,0,0,0,5.51,5.41,15.081,15.081,0,0,0,7,1.84c7.55,0,15.77-5.22,15.77-16v-4.45c-2.61,4.74-8.22,9.48-17.22,9.48-15.28,0-27.08-11.61-27.08-27.95,0-17.32,12.38-28.35,27.08-28.35,7.64,0,14.22,3.49,17.22,8.71V2227h12.77Zm-44.4-20.31c0,9.28,6.67,16.34,15.86,16.34a15.14,15.14,0,0,0,11.32-4.54A16.26,16.26,0,0,0,510,2254a17.91,17.91,0,0,0-3.87-11.41c-2.52-3.2-6.48-5.32-12-5.32a15.76,15.76,0,0,0-15.86,16.15Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_167",
    "data-name": "Caminho 167",
    d: "M585.36,2280.19h-12.7v-7.65c-3.39,6.2-10.46,9.3-17.92,9.3-17,0-27-13.28-27-28.3,0-16.76,12.11-28.19,27-28.19,9.69,0,15.6,5.13,17.92,9.4V2227h12.7Zm-45-26.35c0,6.58,4.75,16.18,16.18,16.18a15.09,15.09,0,0,0,14.15-8.53,18.218,18.218,0,0,0,2-7.46,16.58,16.58,0,0,0-1.45-7.46,15.61,15.61,0,0,0-14.83-9.4c-10.27,0-16.08,8.33-16.08,16.57Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_168",
    "data-name": "Caminho 168",
    d: "M594.3,2227h11.92v6.68c1.17-2.42,6.3-8.33,15.51-8.33a17.269,17.269,0,0,1,13.08,5.43,24.7,24.7,0,0,1,3.2,4.84,22.084,22.084,0,0,1,3.87-5,19.561,19.561,0,0,1,13.57-5.23c4.46,0,10.08,1.16,14.15,5.33,4.84,5,5.81,9.4,5.81,20.35v29.17H662.72v-28.69c0-3.39-.29-7.07-2.13-9.88-1.36-2.62-3.88-4.36-8.34-4.36s-7.56,1.94-9.2,4.84-1.84,5.72-1.84,8.92v29.17h-12.7V2251a19.321,19.321,0,0,0-1.65-8.82c-1.55-2.81-4.16-4.84-8.72-4.94a9.83,9.83,0,0,0-9.11,4.94,19.111,19.111,0,0,0-2,9.21v28.78H594.3Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#575e62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_30",
    "data-name": "Ret\\xE2ngulo 30",
    width: 12.67,
    height: 11.32,
    transform: "translate(-2817.12 1950.242)",
    fill: "#bac108"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_169",
    "data-name": "Caminho 169",
    d: "M219.7,2247.09l-26.92,15.54a2.34,2.34,0,0,1-3.5-2V2225.3a1.092,1.092,0,0,0,0,.18v.1a7.62,7.62,0,0,0,3.83,6.18Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#888f08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_170",
    "data-name": "Caminho 170",
    d: "M246.26,2188.93v72.3a7.69,7.69,0,0,1-3.85-1l-7.69-4.44-6.14-3.54-8.88-5.13-26.58-15.35a7.59,7.59,0,0,1-3.83-6.18.341.341,0,0,1,0-.1v-.18a1.211,1.211,0,0,1,0-.19h0a.863.863,0,0,1,0-.16,5.489,5.489,0,0,1,0-.58,7.57,7.57,0,0,1,3.81-5.92L242.41,2190a7.69,7.69,0,0,1,3.85-1.07Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#bac108"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_171",
    "data-name": "Caminho 171",
    d: "M219.7,2247.09l-5,2.87s-19.47-14.09-22.9-17.77a10.36,10.36,0,0,1-2.53-6.63,7.59,7.59,0,0,0,3.83,6.18Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#6d7225"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_172",
    "data-name": "Caminho 172",
    d: "M272.82,2247.09l26.92,15.54a2.34,2.34,0,0,0,3.5-2v-35.15a.338.338,0,0,1,0,.1,7.59,7.59,0,0,1-3.83,6.18Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#888f08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_173",
    "data-name": "Caminho 173",
    d: "M246.26,2188.93v72.3a7.69,7.69,0,0,0,3.85-1l7.69-4.44,6.14-3.54,8.88-5.13,26.58-15.35a7.59,7.59,0,0,0,3.83-6.18.339.339,0,0,0,0-.1v-.18a1.211,1.211,0,0,0,0-.19h0a.864.864,0,0,0,0-.16,5.5,5.5,0,0,0,0-.58,7.57,7.57,0,0,0-3.81-5.92L250.11,2190a7.691,7.691,0,0,0-3.85-1.07Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#a4ab09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_174",
    "data-name": "Caminho 174",
    d: "M272.82,2247.09l5,2.87s19.47-14.09,22.91-17.77a10.38,10.38,0,0,0,2.52-6.63,7.59,7.59,0,0,1-3.83,6.18Z",
    transform: "translate(-3263.47 -257.758)",
    fill: "#6d7225"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotipo);
export default __webpack_public_path__ + "static/media/logotipo.1e55f7348a68295eaf8f590d67c6eb4d.svg";
export { ForwardRef as ReactComponent };